import SuccessBanner from "../components/success/SuccessBanner";
import SuccessIntro from "../components/success/SuccessIntro";
import SuccessGoals from "../components/success/SuccessGoals";
import SuccessCreators from "../components/success/SuccessCreators";
import SuccessLogotypes from "../components/success/SuccessLogotypes";
import SuccessRelationsOne from "../components/success/SuccessRelationsOne";
import SuccessRelationsTwo from "../components/success/SuccessRelationsTwo";
import SuccessLogotypesImg2024 from "../assets/img/success/success_logotypes_2024.png";
import SuccessLogotypesImg2025 from "../assets/img/success/success_logotypes_2025.png";

import { Link } from "react-router-dom";

const Success = () => {
  return (
    <>
      <Link to="/" className="back-to-main back-to-main--white">
        POWRÓT DO STRONY GŁÓWNEJ
      </Link>
      <div className="success">
        <SuccessBanner />
        <div className="success_container">
          <SuccessIntro />
          <SuccessGoals />
          <SuccessCreators />
          <SuccessLogotypes />
          <div className="success_logotypes">
            <img
              src={SuccessLogotypesImg2025}
              alt="Sponsorzy strategiczni, organizatorzy, patronat, partnerzy"
            />
          </div>
          <SuccessRelationsOne />

          <div className="success_logotypes">
            <img
              src={SuccessLogotypesImg2024}
              alt="Sponsorzy strategiczni, organizatorzy, patronat, partnerzy"
            />
          </div>
          <SuccessRelationsTwo />
        </div>
      </div>
    </>
  );
};

export default Success;
